import { applyMiddleware, createStore } from "redux";
import thunk from "redux-thunk";
import appMiddleware from "../middleware";
import { rootReducer } from "../reducers";
// import { createLogger } from "redux-logger";

const middlewares = [thunk, appMiddleware];

// logger MUST BE the last middleware in the chain
// if (process.env.NODE_ENV === "development") {
//   middlewares.push(createLogger({ collapsed: true }));
// }

export function configureStore() {
  return createStore(rootReducer, applyMiddleware(...middlewares));
}

export const store = configureStore();
